import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { useCurrentLanguage } from '../../../hooks/useCurrentLanguage';
import { getLanguageName } from '../../utils/utils';
import { CountryFlag } from '../CountryFlag/CountryFlag';
import './LanguageSelector.scss';

export const LanguageSelector = ({ className = '', size = 'sm' }) => {
  const { currentLanguage, supportedLanguages, updateLanguage } = useCurrentLanguage();

  const getImageUrl = (state: string) => `https://flagcdn.com/w20/${state == 'en' ? 'gb' : state}.webp`;

  if (!currentLanguage) return null;

  return (
    <DropdownButton
      alignRight={true}
      variant={'dark'}
      title={<img src={getImageUrl(currentLanguage.toLowerCase())} alt={currentLanguage} className={'mr-1'} />}
      size={size as 'sm' | 'lg'}
      className={className}
    >
      {supportedLanguages.map((lang) => (
        <Dropdown.Item
          key={lang}
          disabled={lang == currentLanguage}
          className={lang == currentLanguage ? 'language-selector-item-disabled' : ''}
          onClick={() => updateLanguage(lang)}
        >
          {lang == currentLanguage && <FontAwesomeIcon icon={faCheckCircle} className={'text-success'} />}
          {lang != currentLanguage && <CountryFlag language={lang} />}
          <span className={'ml-2'}>{getLanguageName(lang)}</span>
        </Dropdown.Item>
      ))}
    </DropdownButton>
  );
};
